import React from 'react';
import styled from 'styled-components';

import { Typography, Table, Row, Divider, Space } from 'antd';
import { FileSearchOutlined } from '@ant-design/icons';
import { getTranslatedString } from 'helpers/i18n';

const { Text } = Typography;

const StyledTable = styled(Table)`
  .ant-table-expand-icon-col {
    width: 24px;
  }
  .ant-table-row-expand-icon-cell {
    padding: 4px 0px;
  }
  .ant-table-tbody > tr > td {
    border: none;
  }
  .ant-table-cell {
    padding: 4px 0;
  }
  tr.ant-table-expanded-row > td,
  tr.ant-table-expanded-row:hover > td {
    background: none;
  }
`;

const applicationColumns = [
  {
    title: getTranslatedString('tenantPortal.application.sideBar.name'),
    dataIndex: 'name',
    key: 'name',
    align: 'left',
  },
];

const SidebarAppDetails = ({ cotenant }) => {
  const { application, lease } = cotenant;
  const { lease_pricing } = lease;

  const unitDetails = {
    key: 1,
    name: application.unit?.unit_type_name,
    expandableItems: [
      getTranslatedString('tenantPortal.application.sideBar.unitNumber', {
        unit_number: application.unit?.unit_number,
      }),
    ],
  };

  const occupantDetails = () => {
    const cotenants = application.cotenants?.map((cotenant) => cotenant.full_name);
    const additionalOccupants = application.additional_occupants?.map(
      (additionalOccupant) => additionalOccupant.full_name
    );

    const cotenantString =
      cotenants?.length > 1
        ? getTranslatedString('tenantPortal.application.sideBar.applicants', {
            applicant_length: cotenants.length,
          })
        : getTranslatedString('tenantPortal.application.sideBar.oneApplicant');
    const additionalOccupantString =
      additionalOccupants?.length > 0
        ? getTranslatedString('tenantPortal.application.sideBar.occupants', {
            occupant_length: additionalOccupants.length,
          })
        : '';

    return {
      key: 2,
      name: `${cotenantString}${additionalOccupantString}`,
      expandableItems: [...cotenants, additionalOccupants],
    };
  };

  const rentableItems = {
    key: 3,
    name:
      lease_pricing.lease_charges.length > 1
        ? getTranslatedString('tenantPortal.application.sideBar.rentableItems', {
            rentable_length: lease_pricing.lease_charges.length,
          })
        : getTranslatedString('tenantPortal.application.sideBar.oneRentableItem'),
    expandableItems: lease_pricing.lease_charges.map(
      (lease_charge) => `${lease_charge.item_type} ${lease_charge.ancillary_item.asset_number}`
    ),
  };

  let applicationDetails = [unitDetails, occupantDetails()];

  if (lease_pricing.lease_charges.length > 0) {
    applicationDetails.push(rentableItems);
  }

  return (
    <>
      <Divider />
      <Space>
        <FileSearchOutlined />
        <Text strong>
          {getTranslatedString('tenantPortal.application.sideBar.applicationDetails')}
        </Text>
      </Space>
      <StyledTable
        showHeader={false}
        pagination={false}
        columns={applicationColumns}
        expandable={{
          expandedRowRender: (record) =>
            record.expandableItems.map((item, index) => (
              <Row key={`sidebarDetails-${index}`} justify="space-between">
                <Text type="secondary">{item}</Text>
              </Row>
            )),
        }}
        dataSource={applicationDetails}
      />
    </>
  );
};

export default SidebarAppDetails;
